import React from "react";

const LAYOUT_STYLE_ID = "profile-partner-layout-styles-v6";

export const useProfilePartnerLayoutStyles = () => {
  React.useEffect(() => {
    [
      "profile-partner-layout-styles",
      "profile-partner-layout-styles-v2",
      "profile-partner-layout-styles-v3",
      "profile-partner-layout-styles-v4",
      "profile-partner-layout-styles-v5",
    ].forEach((id) => document.getElementById(id)?.remove());
    if (document.getElementById(LAYOUT_STYLE_ID)) return;
    const styleSheet = document.createElement("style");
    styleSheet.id = LAYOUT_STYLE_ID;
    styleSheet.textContent = `
      .app-content .profile-content.profile-content--partner {
        width: 100%;
        max-width: 100%;
        padding: 0 !important;
        overflow-x: hidden;
        box-sizing: border-box;
      }
      .profile-partner-layout {
        display: grid;
        grid-template-columns: minmax(0, 380px) minmax(0, 1fr);
        gap: 20px;
        align-items: start;
        padding: 12px;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
      }
      .profile-partner-layout__left,
      .profile-partner-layout__right {
        min-width: 0;
        max-width: 100%;
      }
      .profile-partner-layout__left {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
      .profile-partner-identity-card {
        display: contents;
      }
      .profile-partner-panel__summary--identity {
        display: none;
      }
      .profile-partner-panel {
        background: #ffffff;
        border-radius: 20px;
        box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
        display: flex;
        flex-direction: column;
        min-height: 420px;
        overflow: hidden;
        max-width: 100%;
        min-width: 0;
      }
      .profile-partner-panel__head {
        flex-shrink: 0;
        border-bottom: none;
        background: #212529;
        max-width: 100%;
        overflow: hidden;
      }
      .profile-partner-panel__head .nav-tabs {
        max-width: 100%;
      }
      .profile-partner-panel__body {
        flex: 1;
        padding: 20px 24px;
        overflow-x: auto;
        overflow-y: visible;
        min-height: 0;
        max-width: 100%;
        box-sizing: border-box;
      }
      .profile-partner-panel__body .profile-panel-pane {
        display: block;
        max-width: 100%;
        overflow-x: auto;
      }
      .profile-partner-panel__body #tracking.profile-panel-pane {
        min-height: 0 !important;
        background: transparent !important;
        padding: 0 !important;
      }
      .profile-partner-panel__body #informacion.profile-panel-pane {
        padding: 0 !important;
      }
      .profile-partner-panel__body .movimientos-tab-pane.profile-panel-pane {
        margin: 0 !important;
        padding: 0 !important;
        min-height: 0 !important;
      }
      @media (max-width: 991.98px) {
        .profile-partner-layout {
          grid-template-columns: 1fr;
          gap: 12px;
        }
        .profile-partner-layout__left .profile-personal-summary {
          display: none !important;
        }
        .profile-partner-identity-card {
          display: grid;
          grid-template-columns: 84px minmax(0, 1fr);
          grid-template-rows: auto auto;
          column-gap: 12px;
          row-gap: 10px;
          align-items: start;
          padding: 12px;
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          box-shadow:
            0 8px 28px rgba(15, 23, 42, 0.1),
            0 2px 8px rgba(15, 23, 42, 0.06);
          overflow: hidden;
        }
        .profile-partner-identity-card > .profile-hero-card {
          grid-column: 1;
          grid-row: 1;
          align-self: start;
          width: 84px;
          min-width: 84px;
          max-width: 84px;
          border-radius: 12px;
          box-shadow: none;
          border: 1px solid #e2e8f0;
        }
        .profile-partner-identity-card .profile-hero-card__photo-wrap {
          width: 84px;
          height: 84px;
          min-height: 84px;
          max-height: 84px;
          aspect-ratio: 1 / 1;
        }
        .profile-partner-panel__summary--panel {
          display: none !important;
        }
        .profile-partner-panel__summary--identity {
          display: contents !important;
        }
        .profile-partner-identity-card .profile-partner-panel__summary-info {
          grid-column: 2;
          grid-row: 1;
          align-self: center;
          min-width: 0;
          padding: 0 !important;
        }
        .profile-partner-identity-card .profile-partner-panel__summary-info .profile-partner-panel__summary-name {
          font-size: 1.05rem;
        }
        .profile-partner-identity-card .profile-partner-panel__summary-badges {
          grid-column: 1 / -1;
          grid-row: 2;
          justify-content: flex-start;
          gap: 8px;
          width: 100%;
        }
        .profile-partner-panel {
          min-height: 360px;
        }
      }
      @media (max-width: 575.98px) {
        .profile-partner-layout {
          padding: 8px;
          gap: 10px;
        }
        .profile-partner-identity-card {
          grid-template-columns: 76px minmax(0, 1fr);
          column-gap: 10px;
          padding: 10px;
        }
        .profile-partner-identity-card > .profile-hero-card {
          width: 76px;
          min-width: 76px;
          max-width: 76px;
        }
        .profile-partner-identity-card .profile-hero-card__photo-wrap {
          width: 76px;
          height: 76px;
          min-height: 76px;
          max-height: 76px;
        }
        .profile-partner-identity-card .profile-partner-panel__summary-info .profile-partner-panel__summary-name {
          font-size: 1rem;
        }
        .profile-partner-panel {
          border-radius: 16px;
          min-height: 0;
        }
        .profile-partner-panel__body {
          padding: 14px 12px;
        }
      }
    `;
    document.head.appendChild(styleSheet);
  }, []);
};
